import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys: AllRouteEndpoints[] = [];
